import { colors } from '../constants';
const styleOverrides = {
  paper: {
    '&.OriSelectPaper': {
      border: `1px solid ${colors.oriGrey[300]}`,
      borderRadius: 5,
      marginTop: '5px'
    }
  }
};
export default {
  styleOverrides
};